import * as yup from 'yup';

export const notesValidation = yup.string().max(500);
export const referenceIdValidation = yup.string().max(90);
const URLRegex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/;

export const createTransferValidation = yup.object().shape({
    referenceId: yup.string().max(90, "Order ID must be at most 90 characters.").required("Order ID is required").matches(/[^\s]+/, 'Spaces are not allowed'),
    storeURL: yup.string().matches(URLRegex, 'Please enter valid URL').matches(/[^\s]+/, 'Spaces are not allowed'),
    buyerName: yup.string().max(90, "Buyer name must be at most 90 characters.").required("Buyer name is required").matches(/[^\s]+/, 'Spaces are not allowed'),
    buyerPhone: yup.string().matches(/^\d{10}$/, 'Enter valid phone number').required('Phone number is required'),
    buyerEmail: yup.string().email('Enter valid email address').required('Email is required').matches(/[^\s]+/, 'Spaces are not allowed'),
    modelType: yup.string().max(90, "Model type must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
    street: yup.string().max(90, "Street must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
    city: yup.string().max(90, "City must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
    state: yup.string().max(90, "State must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
    zipCode: yup.string().min(5, "Enter valid Zip code.").max(5, "Enter valid Zip code."),
    notes: yup.string().max(500, "Notes must be at most 500 characters.").matches(/[^\s]+/, 'Spaces are not allowed'),
});


export const regexFullLicense = /^(\d)-?(\d\d)-?[\d]{3}-?[\d]{2}-?[\d]{1}[a-zA-Z]{1}-?(\d\d\d\d\d)$/;
export const regexFullLicenseWithMask = /^\d-\d{2}-xxx-xx-xx-\d{5}$/;
export const regexEightDigitsLicense = /^\d{8}$/;
export const regexEmployeeIdentificationNumber = /^\d{2}-\d{7}$/;
export const regexControlNumber = /^\d{7}-[A-Z]\d{2}-\d{3}$/;
export const licenseApprovalValidation = yup.object().shape({
    full_license_key: yup.string().required("License number is required.").matches(regexFullLicense, "Enter valid license number."),
    printed_name: yup.string().min(1, "").max(90, "Name must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed.'),
    position_title: yup.string().min(1, "").max(90, "Title must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed.')
});
export const sotTaxStampsValidation = yup.object().shape({
    license_key: yup.number().required("License number is required."),
    business_name: yup.string().required("Business name is required."),
    employee_identification_number: yup.string().required("Employee identification number is required.").matches(regexEmployeeIdentificationNumber, "Enter valid employee identification number"),
    special_tax_period_start_date: yup.string().required("Start date is required."),
    special_tax_period_end_date: yup.string().required("End date is required."),
    control_number: yup.string().optional(),
    sot_year: yup.number().required("SOT Year is required.").min(1900, "SOT Year must be 1900 or later.").max(2100, "SOT Year must be 2100 or earlier."),
    date_of_tax_stamp_receipt: yup.string().required("Receipt date is required."),
    type_of_operation: yup.string().required("Types of operation conducted is required."),
    name_and_principal_business_address: yup.string().required("Principal business address is required.").max(500, 'Principal business address must be at most 500 characters.'),
    actual_physical_business_address: yup.string().required("Actual physical business address is required.").max(500, 'Actual physical business address must be at most 500 characters.'),
    number_of_locations: yup.string().required("Number of locations is required."),
    annual_tax_rate: yup.string().required("Annual tax rate name is required."),
});
export const loaApprovalValidation = yup.object().shape({
    license_key: yup.string().required("License number is required.").test(
        'loa-license-validation',
        'Enter valid license number.',
        (value) => {
            return regexFullLicense.test(value) || regexEightDigitsLicense.test(value);
        }
    ),
    issue_date: yup.string().required("Issue date is required."),
    expiry_date: yup.string().required("Expiry date is required."),
});
export const textareaLengthValidation = yup.object().shape({
    textarea: yup.string().max(200, "Text must be at most 200 characters.")
});
export const customAddressValidation = yup.object().shape({
    street: yup.string().min(1, "").max(90, "Street must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed').required(),
    city: yup.string().min(1, "").max(90, "City must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed').required(),
    state: yup.string().min(1, "").max(90, "State must be at most 90 characters.").matches(/[^\s]+/, 'Spaces are not allowed').required(),
    zipcode: yup.string().min(1, "").length(5, "Enter valid zip code.").required()
});

export const manageDealerProfileValidation = yup.object().shape({
    full_license_key: yup.string().required("License number is required.").matches(regexFullLicense, "Enter valid license number."),
    email: yup.string().trim().required("Email is required"),   
    domain: yup.string().trim().matches(/^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,11}$/, "Invalid domain name").required("Enter domain name!"),
    bcc_email: yup.string().trim().transform(value => value === "" ? null : value)
    .nullable().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Enter valid email address').email('Enter valid email address'),   
    name: yup.string().trim().required("Store name is required"),   
    store_email: yup.string().trim().transform(value => value === "" ? null : value)
    .nullable().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, 'Enter valid email address').email('Enter valid email address'),   
    phone: yup.string().required('Phone number is required').matches(/^\d{10}$/, 'Enter valid phone number'),
    website_url: yup.string().required('Website URL is required').matches(
        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        'Please enter a valid website URL'
    ).trim(),
    street: yup.string().trim().required("Street is required"),   
    city: yup.string().trim().required("City is required"),   
    state: yup.string().trim().required("State is required"),   
    zipcode: yup.string().trim().required("Zipcode is required"),   
    
});

export const manageParametersValidation = yup.object().shape({
        dealer_unresponsive_initiation : yup.number()
        .integer("Action must be an integer.")
        .required("*Dealer unresponsive action timeout is required."),
        dealer_unresponsive_confirmation :yup.number()
        .integer("Action must be an integer.")
        .required("*Dealer unresponsive confirmation action timeout is required."),
        dealer_sms_email_update_timeout: yup.number()
        .integer("Action must be an integer.")
        .required("*Dealer sms email update action timeout is required."),
        ffl_support_email_update_timeout :yup.number()
        .integer("Action must be an integer.")
        .required("*Support email update action timeout is required."),
        store_agent_email_update_timeout : yup.number()
        .integer("Action must be an integer.")
        .required("*store agent email update action timeout is required."),
        customer_action_timeout:yup.number()
        .integer("Action must be an integer.")
        .required("*customer action timeout is required."),
        dealer_last_chance_action_timeout: yup.number()
        .integer("Action must be an integer.")
        .required("*dealer last chance action timeout is required."),
        dealer_documents_processing_timeout :yup.number()
        .integer("Action must be an integer.")
        .required("*dealer documents processing timeout is required."),
        customer_reassignment_email_reminder_timeout: yup.number()
        .integer("Action must be an integer.")
        .required("*customer reassignment email reminder action timeout is required."),
});

export const manageTermsAndConditions = yup.object().shape({ terms_and_condition: yup.string() });

export const sotEditValidation = yup.object().shape({
    licenseKey: yup.number().required("License number is required."),
    businessName: yup.string().required("Business name is required."),
    employeeIdentificationNumber: yup.string().required("Employee identification number is required.").matches(regexEmployeeIdentificationNumber, "Enter valid employee identification number"),
    specialTaxPeriodStartDate: yup.string().required("Start date is required."),
    specialTaxPeriodEndDate: yup.string().required("End date is required."),
    controlNumber: yup.string().required("Control number is required."),
    dateOfTaxStampReceipt: yup.string().required("Receipt date is required."),
    typeOfOperation: yup.string().required("Types of operation conducted is required."),
    principalBusinessAddress: yup.string().required("Principal business address is required.").max(500, 'Principal business address must be at most 500 characters.'),
    actualPhysicalBusinessAddress: yup.string().required("Actual physical business address is required.").max(500, 'Actual physical business address must be at most 500 characters.'),
    numberOfLocations: yup.string().required("Number of locations is required."),
    annualTaxRate: yup.string().required("Annual tax rate name is required."),
});
